var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLanguageBlack24DpThree(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "language_black_24dp_1_",
    "data-name": "language_black_24dp (1)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_474",
    "data-name": "Path 474",
    d: "M0,0H20V20H0Z",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6768",
    "data-name": "Group 6768",
    transform: "translate(1.525 1.825)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_475",
    "data-name": "Path 475",
    d: "M9.287,2A7.355,7.355,0,0,0,2,9.42a7.355,7.355,0,0,0,7.287,7.42,6.691,6.691,0,0,0,2.568-.486c-.008,0,.043-3.817.117-6.2,0-.612.006-.8.218-1.072.492-.628,1.888-.5,4.348-.482A7.216,7.216,0,0,0,9.287,2Zm5.055,4.452H12.19a11.734,11.734,0,0,0-1.007-2.642A5.881,5.881,0,0,1,14.342,6.452ZM9.294,3.514a10.531,10.531,0,0,1,1.393,2.938H7.9A10.531,10.531,0,0,1,9.294,3.514ZM3.648,10.9a5.9,5.9,0,0,1,0-2.968H6.114a12.464,12.464,0,0,0-.1,1.484,12.464,12.464,0,0,0,.1,1.484Zm.6,1.484H6.4A11.734,11.734,0,0,0,7.4,15.03a5.849,5.849,0,0,1-3.158-2.642ZM6.4,6.452H4.247A5.849,5.849,0,0,1,7.4,3.811,11.734,11.734,0,0,0,6.4,6.452Zm2.9,8.875A10.531,10.531,0,0,1,7.9,12.389h2.786A10.531,10.531,0,0,1,9.294,15.327ZM11,10.9H7.587A11.1,11.1,0,0,1,7.471,9.42a11.006,11.006,0,0,1,.117-1.484H11a11.006,11.006,0,0,1,.117,1.484A11.1,11.1,0,0,1,11,10.9Zm1.473-2.968H14.94C15.057,8.411,12.533,8.426,12.474,7.936Z",
    transform: "translate(-2 -2)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_478",
    "data-name": "Path 478",
    d: "M21.425,8h-4.65A.777.777,0,0,0,16,8.775v7.75a.777.777,0,0,0,.775.775h4.65a.777.777,0,0,0,.775-.775V8.775A.777.777,0,0,0,21.425,8Zm-.775,6.975h-3.1V9.55h3.1Z",
    transform: "translate(-5.525 -0.825)",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguageBlack24DpThree);
export default __webpack_public_path__ + "static/media/language_black_24dpThree.3b63749377f59f5cd6efa4f4c0c6e1a7.svg";
export { ForwardRef as ReactComponent };